<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="1341"></ucMenu>
					<div class="right_con">
						<div class="record_main">
							<el-card shadow="never" style="min-height:650px;">
                <!-- 标题 -->
                <div class="board_title">
                  <h3>店铺看板</h3>
                  <div class="board_title_actions">
                    <el-button v-if="is_host" size="small" @click="openShopGroupManageDialog">分组管理</el-button>
                    <el-button v-if="is_host" size="small" type="primary" :disabled="selectedRows.length === 0" @click="openShopBatchGroupDialog()">批量设置分组</el-button>
                  </div>
                </div>
								<!-- 筛选区域 -->
								<div class="filter_wrap">
									<!-- 平台类型 Tab -->
									<div class="platform_tabs_wrap">
										<span class="platform_tab" :class="{active: searchData.platform === 1}" @click="handlePlatformTab(1)">抖店</span>
										<span class="platform_tab" :class="{active: searchData.platform === 7}" @click="handlePlatformTab(7)">微信小店</span>
									</div>
									<div class="filter_row">
										<div class="filter_item">
											<span class="filter_label">店铺名称：</span>
											<el-select v-model="searchData.shop_id" placeholder="全部" clearable size="small" style="width:160px" filterable>
												<el-option v-for="item in shopOptions" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
											</el-select>
										</div>
										<div class="filter_item">
											<span class="filter_label">店铺分组：</span>
											<el-select v-model="searchData.group_id" placeholder="全部分组" clearable size="small" style="width:150px" filterable @change="setChange">
												<el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
										<!-- 隐藏营业额筛选 -->
										<!--
										<div class="filter_item">
											<span class="filter_label">营业额：</span>
											<el-select v-model="searchData.sales_range" placeholder="全部" clearable size="small" style="width:140px">
												<el-option v-for="item in salesRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select>
										</div>
										-->
										<div class="filter_item">
											<span class="filter_label">体验分：</span>
											<el-select v-model="searchData.score_range" placeholder="全部" clearable size="small" style="width:140px">
												<el-option v-for="item in scoreRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select>
										</div>
										<div class="filter_item">
											<span class="filter_label">是否违规：</span>
											<el-select v-model="searchData.has_violation" placeholder="全部" clearable size="small" style="width:120px">
												<el-option v-for="item in violationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select>
										</div>
                                        <div class="filter_item">
											<span class="filter_label">是否授权：</span>
											<el-select v-model="searchData.has_auth" placeholder="全部" clearable size="small" style="width:120px">
												<el-option v-for="item in authOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select>
										</div>
									</div>
									<div class="filter_row">
										<!-- 隐藏时间筛选，默认使用实时数据 -->

										<div class="filter_item">
											<span class="filter_label">时间：</span>
											<span class="time_tag" :class="{active: timeSelectId === item.id}" v-for="item in timeOptions" :key="item.id" @click="timeTagClick(item)">{{item.name}}</span>
											<el-date-picker
												v-model="displayDateRange"
												type="daterange"
												range-separator="-"
												size="small"
												value-format="yyyy-MM-dd"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												:picker-options="datePickerOptions"
								@change="customDateChange"
												style="width:240px;margin-left:10px;">
											</el-date-picker>
										</div>

										<div class="filter_btns">
											<span v-if="selectedRows.length > 0" class="selected_hint">已选 {{ selectedRows.length }} 个店铺</span>
											<el-button type="primary" size="small" @click="handleSearch">查询</el-button>
											<el-button size="small" @click="handleReset">重置</el-button>
											<el-button size="small" @click="openFieldConfig">指标配置</el-button>
										</div>
									</div>
								</div>

								<!-- 数据时间显示 -->
								<div v-if="dataTime" class="data_time_info">
									<span class="data_time_label">数据时间：</span>
									<span class="data_time_value">{{dataTime}}</span>
								</div>

								<!-- 数据表格 -->
								<el-table
									:data="tableData"
									:header-cell-style="headerCellStyle"
									:header-cell-class-name="headerCellClass"
									v-loading="loading"
									border
									style="width:100%;margin-top:15px;"
									@selection-change="handleSelectionChange">
									<el-table-column type="selection" width="46" fixed="left"></el-table-column>
									<!-- 固定列 -->
									<el-table-column align="left" prop="shop_name" label="店铺名称" width="160" fixed="left" class-name="col-fixed">
										<template slot-scope="scope">
											<div class="shop_name_cell">
												<div class="shop_name">{{scope.row.shop_name}}</div>
												<div class="platform_tag_small" :class="platformClass(scope.row.platform)">{{platformName(scope.row.platform)}}</div>
												<div v-if="scope.row.group_name" class="shop_group_tag">{{scope.row.group_name}}</div>
												<div v-else class="shop_group_tag shop_group_tag_empty">未分组</div>
											</div>
										</template>
									</el-table-column>
									<el-table-column align="center" prop="score" label="体验分" width="75" fixed="left" class-name="col-fixed">
										<template slot-scope="scope">
											<span class="score_badge" :class="scoreClass(scope.row.score)">{{scope.row.score}}</span>
										</template>
									</el-table-column>
                                    <el-table-column align="center" prop="score" label="授权状态" width="75" fixed="left" class-name="col-fixed">
										<template slot-scope="score_status">
                                            <el-tag size="small" v-if="score_status.row.score_update_time_status == 1"  type="success" effect="dark">已授权</el-tag>
                                            <el-tag size="small" v-else-if="score_status.row.score_update_time_status == 2"  type="danger" effect="dark">未授权</el-tag>
                                            <el-tag size="small" v-else type="danger" effect="dark">未知</el-tag>
										</template>
									</el-table-column>
									<!-- 按分组渲染多级表头 -->
									<el-table-column v-for="group in activeGroups" :key="group.name" :label="group.name" align="center" :class-name="'col-group-' + group.type">
										<el-table-column
											v-for="col in group.fields"
											:key="col.key"
											align="center"
											:prop="col.key"
											:min-width="col.shortWidth || 100"
											:class-name="'col-group-' + group.type">
											<template slot="header">
												<el-tooltip v-if="col.tip" :content="col.label" placement="top" effect="light">
													<span class="col_header">{{col.short}}</span>
												</el-tooltip>
												<span v-else class="col_header">{{col.short}}</span>
											</template>
											<template slot-scope="scope">
												<span :class="cellClass(col, scope.row[col.key])">{{formatCell(col, scope.row[col.key])}}</span>
											</template>
										</el-table-column>
									</el-table-column>
									<!-- 操作列 -->
									<el-table-column align="center" label="操作" width="85" fixed="right" class-name="col-fixed">
										<template slot-scope="scope">
											<div class="action_btns">
												<el-button type="primary" size="mini" @click="goDetail(scope.row)">查看更多</el-button>
												<el-button type="warning" size="mini" @click="showViolations(scope.row)">查看违规</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>

								<!-- 移除分页 -->
							</el-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>

		<!-- 违规信息弹窗 -->
		<el-dialog :title="violationDialogTitle" :visible.sync="showViolationDialog" width="900px" @close="onViolationDialogClose">
			<el-table :data="violationList" v-loading="violationLoading" border style="width:100%;">
				<el-table-column align="center" prop="violation_time" label="违规时间" width="100">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.violation_time)}}
					</template>
				</el-table-column>
				<el-table-column align="left" prop="violation_type" label="违规类型" width="100"></el-table-column>
				<el-table-column align="left" prop="violation_title" label="违规标题" min-width="150" show-overflow-tooltip></el-table-column>
				<el-table-column align="left" prop="violation_product" label="违规产品" min-width="120" show-overflow-tooltip></el-table-column>
				<el-table-column align="right" prop="frozen_amount" label="冻结金额" width="90">
					<template slot-scope="scope">
						¥{{scope.row.frozen_amount}}
					</template>
				</el-table-column>
				<el-table-column align="right" prop="deduction_amount" label="扣款金额" width="90">
					<template slot-scope="scope">
						¥{{scope.row.deduction_amount}}
					</template>
				</el-table-column>
				<!-- 隐藏处理状态列 -->
				<!--
				<el-table-column align="center" prop="status" label="处理状态" width="80">
					<template slot-scope="scope">
						<span :class="{'text-danger': scope.row.status === '待处理', 'text-success': scope.row.status === '已处理'}">{{scope.row.status || '--'}}</span>
					</template>
				</el-table-column>
				-->
			</el-table>
			<div class="turn_page" style="margin-top:15px;">
				<Pagination :total="violationPage.total" :page.sync="violationPage.page" :limit.sync="violationPage.limit" @pagination="loadViolations" layout="total, prev, pager, next" :page-sizes="[20]"/>
			</div>
		</el-dialog>

		<!-- 指标配置弹窗 -->
		<el-dialog title="指标配置" :visible.sync="showFieldConfig" width="720px" @close="onConfigClose">
			<div class="field_config_body">
				<div class="field_group" v-for="group in fieldGroups" :key="group.name">
					<div class="group_title">
						<el-checkbox :indeterminate="isGroupIndeterminate(group)" :value="isGroupAllChecked(group)" @change="toggleGroupAll(group, $event)">{{group.name}}</el-checkbox>
						<span class="group_count">{{getGroupCheckedCount(group)}} / {{group.fields.length}}</span>
					</div>
					<el-checkbox-group v-model="tempSelectedFields">
						<el-checkbox v-for="field in group.fields" :key="field.key" :label="field.key">{{field.label}}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="showFieldConfig = false">取消</el-button>
				<el-button size="small" type="primary" @click="confirmFieldConfig">确认</el-button>
			</span>
		</el-dialog>

		<el-dialog title="店铺分组管理" :visible.sync="groupManageVisible" width="640px" custom-class="shop-group-manage-dialog">
			<div class="group_manage_toolbar">
				<el-button size="small" type="primary" @click="handleAddShopGroup">新增分组</el-button>
			</div>
			<div class="group_manage_body">
				<el-table :data="groupList" size="small" border v-loading="groupLoading" :max-height="360">
					<el-table-column prop="name" label="分组名称" min-width="180"></el-table-column>
					<el-table-column prop="shop_count" label="店铺数" width="90" align="center"></el-table-column>
					<el-table-column prop="sort" label="排序" width="90" align="center"></el-table-column>
					<el-table-column label="操作" width="150" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="handleEditShopGroup(scope.row)">编辑</el-button>
							<el-button type="text" size="small" @click="handleDeleteShopGroup(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-empty v-if="groupList.length === 0 && !groupLoading" description="暂无分组" :image-size="90"></el-empty>
			</div>
		</el-dialog>

		<el-dialog :title="groupFormEdit ? '编辑分组' : '新增分组'" :visible.sync="groupFormVisible" width="400px">
			<el-form :model="groupForm" label-width="80px">
				<el-form-item label="分组名称">
					<el-input v-model="groupForm.name" maxlength="50" show-word-limit placeholder="请输入分组名称"></el-input>
				</el-form-item>
				<el-form-item label="排序值">
					<el-input-number v-model="groupForm.sort" :min="0" :max="9999" style="width:100%;"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="groupFormVisible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="groupFormLoading" @click="submitShopGroupForm">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="设置店铺分组" :visible.sync="batchGroupVisible" width="420px">
			<el-form label-width="90px">
				<el-form-item label="已选店铺">
					<div class="batch_group_tip">{{ batchGroupRows.length }} 个</div>
				</el-form-item>
				<el-form-item label="选择分组">
					<el-select v-model="batchGroupId" placeholder="请选择分组" clearable style="width:100%;">
						<el-option label="移出分组" :value="0"></el-option>
						<el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="batchGroupVisible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="batchGroupLoading" @click="submitShopBatchSetGroup">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import Pagination from "@/components/pagination/pagination.vue";
import { mapActions, mapState } from "vuex";
import { getShopViolations } from "@/api/main/shop_board";

// 抖店指标分组定义
const douyinFieldGroups = [
	{
		name: '交易指标',
		type: 'trade',
		fields: [
			{ key: 'pay_amt', label: '用户支付金额', short: '支付金额', fmt: 'money', shortWidth: 100 },
			{ key: 'refunded_pay_amt_pay_time', label: '退款后用户支付金额(支付时间)', short: '退后支付额', tip: true, fmt: 'money', shortWidth: 100 },
			{ key: 'pay_cnt', label: '成交订单数', short: '订单数', fmt: 'num', shortWidth: 80 },
			{ key: 'pay_ucnt', label: '成交人数', short: '成交人数', fmt: 'num', shortWidth: 85 },
			{ key: 'per_usr_pay_amt', label: '客单价', short: '客单价', fmt: 'money', shortWidth: 80 },
			{ key: 'income_amt', label: '成交金额', short: '成交金额', fmt: 'money', shortWidth: 100 },
			{ key: 'net_income_amt', label: '净成交金额', short: '净成交额', fmt: 'money', shortWidth: 95 },
			{ key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', short: '优惠券额', tip: true, fmt: 'money', shortWidth: 90 },
			{ key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '退款后智能优惠券金额(支付时间)', short: '退后券额', tip: true, fmt: 'money', shortWidth: 90 },
			{ key: 'pay_plat_cost_amt', label: '平台补贴金额', short: '平台补贴', fmt: 'money', shortWidth: 90 },
			{ key: 'refund_pay_plat_cost_amt_pay_time', label: '退款后电商平台补贴金额(支付时间)', short: '退后补贴', tip: true, fmt: 'money', shortWidth: 90 },
			{ key: 'author_subsidy_amt', label: '达人补贴金额', short: '达人补贴', fmt: 'money', shortWidth: 90 },
			{ key: 'deposit_pay_amt', label: '预售定金', short: '预售定金', fmt: 'money', shortWidth: 90 },
			{ key: 'pay_combo_cnt', label: '成交件数', short: '成交件数', fmt: 'num', shortWidth: 85 },
			{ key: 'per_pay_combo_price', label: '件单价', short: '件单价', fmt: 'money', shortWidth: 80 },
			{ key: 'net_pay_cnt', label: '净成交订单量', short: '净订单量', fmt: 'num', shortWidth: 85 },
		]
	},
	{
		name: '退款指标',
		type: 'refund',
		fields: [
			{ key: 'refund_amt', label: '成交退款金额(退款时间)', short: '退款额(退时)', tip: true, fmt: 'money', shortWidth: 105 },
			{ key: 'rfndsuc_amt', label: '退款金额(退款时间)', short: '退款额(退)', tip: true, fmt: 'money', shortWidth: 95 },
			{ key: 'refund_amt_pay_time', label: '成交退款金额(支付时间)', short: '退款额(付时)', tip: true, fmt: 'money', shortWidth: 105 },
			{ key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', short: '退款额(付)', tip: true, fmt: 'money', shortWidth: 95 },
			{ key: 'refund_amt_rate', label: '退款率(支付时间)', short: '退款率', tip: true, fmt: 'rate', shortWidth: 80 },
			{ key: 'saling_refund_amt_rate_pay_time', label: '发货前退款率(支付时间)', short: '发前退率', tip: true, fmt: 'rate', shortWidth: 85 },
			{ key: 'ship_refund_amt_rate_pay_time', label: '未收货退款率(支付时间)', short: '未收退率', tip: true, fmt: 'rate', shortWidth: 85 },
			{ key: 'received_refund_amt_rate_pay_time', label: '已收货退款率(支付时间)', short: '已收退率', tip: true, fmt: 'rate', shortWidth: 85 },
			{ key: 'received_return_good_amt_rate_pay_time', label: '已收货退货退款率(支付时间)', short: '收货退货率', tip: true, fmt: 'rate', shortWidth: 90 },
			{ key: 'refund_order_cnt', label: '退款订单数(退款时间)', short: '退单数(退)', tip: true, fmt: 'num', shortWidth: 90 },
			{ key: 'refund_order_cnt_pay_time', label: '退款订单数(支付时间)', short: '退单数(付)', tip: true, fmt: 'num', shortWidth: 90 },
			{ key: 'refund_amt_one_hour_pay_time', label: '1小时成交退款金额(支付时间)', short: '1h退款额', tip: true, fmt: 'money', shortWidth: 90 },
			{ key: 'refund_order_cnt_one_hour_pay_time', label: '1小时退款订单数(支付时间)', short: '1h退单数', tip: true, fmt: 'num', shortWidth: 85 },
			{ key: 'refund_amt_ratio_one_hour_pay_time', label: '1小时成交退款率(支付时间)', short: '1h退款率', tip: true, fmt: 'rate', shortWidth: 85 },
		]
	},
	{
		name: '流量指标',
		type: 'traffic',
		fields: [
			{ key: 'product_show_ucnt', label: '商品曝光人数', short: '曝光人数', fmt: 'bignum', shortWidth: 90 },
			{ key: 'product_click_ucnt', label: '商品点击人数', short: '点击人数', fmt: 'bignum', shortWidth: 90 },
			{ key: 'product_show_click_ucnt_ratio', label: '商品曝光-点击转化率(人数)', short: '曝光点击率', tip: true, fmt: 'rate', shortWidth: 90 },
			{ key: 'product_click_pay_ucnt_ratio', label: '商品点击-成交转化率(人数)', short: '点击成交率', tip: true, fmt: 'rate', shortWidth: 90 },
			{ key: 'product_show_pay_ucnt_ratio', label: '商品曝光-成交转化率(人数)', short: '曝光成交率', tip: true, fmt: 'rate', shortWidth: 90 },
			{ key: 'gpm', label: '千次曝光用户支付金额', short: '千曝支付额', tip: true, fmt: 'money', shortWidth: 95 },
			{ key: 'product_show_pay_cnt_ratio', label: '商品曝光-成交转化率(次数)', short: '曝光成交(次)', tip: true, fmt: 'rate', shortWidth: 100 },
			{ key: 'product_show_cnt', label: '商品曝光次数', short: '曝光次数', fmt: 'bignum', shortWidth: 90 },
			{ key: 'product_click_cnt', label: '商品点击次数', short: '点击次数', fmt: 'bignum', shortWidth: 90 },
			{ key: 'product_show_click_cnt_ratio', label: '商品曝光-点击转化率(次数)', short: '曝光点击(次)', tip: true, fmt: 'rate', shortWidth: 100 },
			{ key: 'product_click_pay_cnt_ratio', label: '商品点击-成交转化率(次数)', short: '点击成交(次)', tip: true, fmt: 'rate', shortWidth: 100 },
		]
	}
];

// 微信小店指标分组定义（基于微信电商罗盘）
const wechatFieldGroups = [
	{
		name: '交易指标',
		type: 'trade',
		fields: [
			{ key: 'income_amt', label: '成交金额', short: '成交金额', fmt: 'money', shortWidth: 100 },
			{ key: 'net_pay_cnt', label: '成交订单数', short: '订单数', fmt: 'num', shortWidth: 80 },
			{ key: 'net_pay_ucnt', label: '成交人数', short: '成交人数', fmt: 'num', shortWidth: 85 },
			{ key: 'pay_amt', label: '下单金额', short: '下单金额', fmt: 'money', shortWidth: 100 },
			{ key: 'pay_cnt', label: '下单订单数', short: '下单数', fmt: 'num', shortWidth: 80 },
			{ key: 'pay_ucnt', label: '下单人数', short: '下单人数', fmt: 'num', shortWidth: 85 },
			{ key: 'per_user_price', label: '客单价', short: '客单价', fmt: 'money', shortWidth: 80 },
		]
	},
	{
		name: '退款指标',
		type: 'refund',
		fields: [
			{ key: 'refund_amt', label: '退款金额', short: '退款金额', fmt: 'money', shortWidth: 95 },
			{ key: 'pay_refund_success_amt', label: '成交退款金额', short: '成交退款额', fmt: 'money', shortWidth: 100 },
		]
	},
	{
		name: '流量指标',
		type: 'traffic',
		fields: [
			{ key: 'product_click_ucnt', label: '商品点击人数', short: '点击人数', fmt: 'bignum', shortWidth: 90 },
		]
	}
];

// 抖店默认选中的指标
const douyinDefaultFields = [
	'pay_amt', 'pay_cnt', 'pay_ucnt', 'per_usr_pay_amt', 'income_amt',
	'refund_amt', 'refund_amt_rate',
	'product_show_ucnt', 'product_click_ucnt', 'product_show_click_ucnt_ratio'
];

// 微信小店默认选中的指标
const wechatDefaultFields = [
	'income_amt', 'net_pay_cnt', 'net_pay_ucnt', 'pay_amt', 'pay_cnt', 'pay_ucnt', 'per_user_price',
	'refund_amt', 'pay_refund_success_amt',
	'product_click_ucnt'
];

// 默认选中的指标
const defaultSelectedFields = [
	'pay_amt', 'pay_cnt', 'pay_ucnt', 'per_usr_pay_amt', 'income_amt',
	'refund_amt', 'refund_amt_rate',
	'product_show_ucnt', 'product_click_ucnt', 'product_show_click_ucnt_ratio'
];

// Mock数据 - 已改用真实接口
/*
const mockData = [
	{
		id: 1, platform: '抖店', shop_name: '美妆旗舰店', score: 4.82, violation_status: '正常',
		pay_amount: 158320.50, refund_pay_amount: 142500.00, order_count: 3256, buyer_count: 2890, avg_price: 48.63, deal_amount: 155000.00, net_deal_amount: 139800.00, coupon_amount: 5200.00, refund_coupon_amount: 4800.00, platform_subsidy: 3200.00, refund_platform_subsidy: 2900.00, influencer_subsidy: 1500.00, presale_deposit: 800.00, deal_item_count: 4500, item_price: 34.44, net_order_count: 3100,
		refund_amount_rt: 15820.50, refund_total_rt: 18200.00, refund_amount_pt: 14500.00, refund_total_pt: 16800.00, refund_rate_pt: '9.8%', pre_ship_refund_rate: '3.2%', unreceived_refund_rate: '2.1%', received_refund_rate: '4.5%', received_return_refund_rate: '3.8%', refund_order_count_rt: 320, refund_order_count_pt: 290, hour1_refund_amount: 2500.00, hour1_refund_order_count: 45, hour1_refund_rate: '1.4%',
		exposure_uv: 256800, click_uv: 38520, exposure_click_rate_uv: '15.0%', click_deal_rate_uv: '7.5%', exposure_deal_rate_uv: '1.1%', thousand_exposure_pay: 616.31, exposure_deal_rate_pv: '0.8%', exposure_pv: 512000, click_pv: 72000, exposure_click_rate_pv: '14.1%', click_deal_rate_pv: '4.5%'
	},
	{
		id: 2, platform: '抖店', shop_name: '潮流服饰专营店', score: 4.65, violation_status: '正常',
		pay_amount: 236580.00, refund_pay_amount: 210000.00, order_count: 5120, buyer_count: 4200, avg_price: 46.21, deal_amount: 230000.00, net_deal_amount: 205000.00, coupon_amount: 8500.00, refund_coupon_amount: 7600.00, platform_subsidy: 4500.00, refund_platform_subsidy: 4100.00, influencer_subsidy: 2800.00, presale_deposit: 1200.00, deal_item_count: 6800, item_price: 33.82, net_order_count: 4800,
		refund_amount_rt: 26580.00, refund_total_rt: 30200.00, refund_amount_pt: 24000.00, refund_total_pt: 27500.00, refund_rate_pt: '11.2%', pre_ship_refund_rate: '4.1%', unreceived_refund_rate: '2.8%', received_refund_rate: '4.3%', received_return_refund_rate: '3.5%', refund_order_count_rt: 530, refund_order_count_pt: 480, hour1_refund_amount: 4200.00, hour1_refund_order_count: 72, hour1_refund_rate: '1.8%',
		exposure_uv: 385000, click_uv: 52000, exposure_click_rate_uv: '13.5%', click_deal_rate_uv: '8.1%', exposure_deal_rate_uv: '1.1%', thousand_exposure_pay: 614.49, exposure_deal_rate_pv: '0.7%', exposure_pv: 780000, click_pv: 105000, exposure_click_rate_pv: '13.5%', click_deal_rate_pv: '4.9%'
	},
	{
		id: 3, platform: '微信小店', shop_name: '家居生活馆', score: 4.91, violation_status: '正常',
		pay_amount: 89500.00, refund_pay_amount: 82000.00, order_count: 1850, buyer_count: 1650, avg_price: 48.38, deal_amount: 87000.00, net_deal_amount: 80000.00, coupon_amount: 3200.00, refund_coupon_amount: 2900.00, platform_subsidy: 1800.00, refund_platform_subsidy: 1600.00, influencer_subsidy: 900.00, presale_deposit: 500.00, deal_item_count: 2400, item_price: 36.25, net_order_count: 1750,
		refund_amount_rt: 7500.00, refund_total_rt: 8800.00, refund_amount_pt: 6800.00, refund_total_pt: 8000.00, refund_rate_pt: '7.6%', pre_ship_refund_rate: '2.5%', unreceived_refund_rate: '1.8%', received_refund_rate: '3.3%', received_return_refund_rate: '2.9%', refund_order_count_rt: 140, refund_order_count_pt: 125, hour1_refund_amount: 1200.00, hour1_refund_order_count: 20, hour1_refund_rate: '1.1%',
		exposure_uv: 125000, click_uv: 21000, exposure_click_rate_uv: '16.8%', click_deal_rate_uv: '7.9%', exposure_deal_rate_uv: '1.3%', thousand_exposure_pay: 716.00, exposure_deal_rate_pv: '0.9%', exposure_pv: 250000, click_pv: 42000, exposure_click_rate_pv: '16.8%', click_deal_rate_pv: '4.4%'
	},
	{
		id: 4, platform: '抖店', shop_name: '数码配件优选', score: 4.38, violation_status: '违规',
		pay_amount: 312000.00, refund_pay_amount: 275000.00, order_count: 6800, buyer_count: 5500, avg_price: 45.88, deal_amount: 305000.00, net_deal_amount: 268000.00, coupon_amount: 12000.00, refund_coupon_amount: 10500.00, platform_subsidy: 6500.00, refund_platform_subsidy: 5800.00, influencer_subsidy: 3500.00, presale_deposit: 1800.00, deal_item_count: 8500, item_price: 35.88, net_order_count: 6200,
		refund_amount_rt: 37000.00, refund_total_rt: 42000.00, refund_amount_pt: 33500.00, refund_total_pt: 38000.00, refund_rate_pt: '12.5%', pre_ship_refund_rate: '5.0%', unreceived_refund_rate: '3.2%', received_refund_rate: '4.3%', received_return_refund_rate: '3.6%', refund_order_count_rt: 720, refund_order_count_pt: 650, hour1_refund_amount: 5800.00, hour1_refund_order_count: 95, hour1_refund_rate: '2.1%',
		exposure_uv: 520000, click_uv: 68000, exposure_click_rate_uv: '13.1%', click_deal_rate_uv: '8.1%', exposure_deal_rate_uv: '1.1%', thousand_exposure_pay: 600.00, exposure_deal_rate_pv: '0.6%', exposure_pv: 1050000, click_pv: 136000, exposure_click_rate_pv: '13.0%', click_deal_rate_pv: '5.0%'
	},
	{
		id: 5, platform: '微信小店', shop_name: '零食小铺', score: 4.75, violation_status: '正常',
		pay_amount: 65200.00, refund_pay_amount: 60500.00, order_count: 2100, buyer_count: 1900, avg_price: 31.05, deal_amount: 63000.00, net_deal_amount: 58500.00, coupon_amount: 2800.00, refund_coupon_amount: 2500.00, platform_subsidy: 1500.00, refund_platform_subsidy: 1300.00, influencer_subsidy: 700.00, presale_deposit: 300.00, deal_item_count: 3200, item_price: 19.69, net_order_count: 2000,
		refund_amount_rt: 4700.00, refund_total_rt: 5500.00, refund_amount_pt: 4200.00, refund_total_pt: 5000.00, refund_rate_pt: '7.2%', pre_ship_refund_rate: '2.0%', unreceived_refund_rate: '1.5%', received_refund_rate: '3.7%', received_return_refund_rate: '3.1%', refund_order_count_rt: 100, refund_order_count_pt: 90, hour1_refund_amount: 800.00, hour1_refund_order_count: 12, hour1_refund_rate: '0.9%',
		exposure_uv: 95000, click_uv: 16500, exposure_click_rate_uv: '17.4%', click_deal_rate_uv: '11.5%', exposure_deal_rate_uv: '2.0%', thousand_exposure_pay: 686.32, exposure_deal_rate_pv: '1.1%', exposure_pv: 188000, click_pv: 33000, exposure_click_rate_pv: '17.6%', click_deal_rate_pv: '6.4%'
	},
	{
		id: 6, platform: '抖店', shop_name: '母婴用品专营', score: 4.88, violation_status: '正常',
		pay_amount: 178900.00, refund_pay_amount: 165000.00, order_count: 3800, buyer_count: 3200, avg_price: 47.08, deal_amount: 175000.00, net_deal_amount: 161000.00, coupon_amount: 6500.00, refund_coupon_amount: 5800.00, platform_subsidy: 3800.00, refund_platform_subsidy: 3400.00, influencer_subsidy: 2000.00, presale_deposit: 900.00, deal_item_count: 5200, item_price: 33.65, net_order_count: 3600,
		refund_amount_rt: 13900.00, refund_total_rt: 16000.00, refund_amount_pt: 12500.00, refund_total_pt: 14500.00, refund_rate_pt: '7.8%', pre_ship_refund_rate: '2.8%', unreceived_refund_rate: '1.9%', received_refund_rate: '3.1%', received_return_refund_rate: '2.6%', refund_order_count_rt: 280, refund_order_count_pt: 250, hour1_refund_amount: 2100.00, hour1_refund_order_count: 35, hour1_refund_rate: '1.2%',
		exposure_uv: 310000, click_uv: 46500, exposure_click_rate_uv: '15.0%', click_deal_rate_uv: '6.9%', exposure_deal_rate_uv: '1.0%', thousand_exposure_pay: 577.10, exposure_deal_rate_pv: '0.7%', exposure_pv: 620000, click_pv: 93000, exposure_click_rate_pv: '15.0%', click_deal_rate_pv: '4.1%'
	},
	{
		id: 7, platform: '微信小店', shop_name: '户外运动装备', score: 4.55, violation_status: '违规',
		pay_amount: 125600.00, refund_pay_amount: 112000.00, order_count: 2600, buyer_count: 2200, avg_price: 48.31, deal_amount: 122000.00, net_deal_amount: 109000.00, coupon_amount: 4500.00, refund_coupon_amount: 4000.00, platform_subsidy: 2500.00, refund_platform_subsidy: 2200.00, influencer_subsidy: 1200.00, presale_deposit: 600.00, deal_item_count: 3400, item_price: 35.88, net_order_count: 2450,
		refund_amount_rt: 13600.00, refund_total_rt: 15800.00, refund_amount_pt: 12200.00, refund_total_pt: 14200.00, refund_rate_pt: '10.8%', pre_ship_refund_rate: '3.8%', unreceived_refund_rate: '2.5%', received_refund_rate: '4.5%', received_return_refund_rate: '3.8%', refund_order_count_rt: 260, refund_order_count_pt: 235, hour1_refund_amount: 2000.00, hour1_refund_order_count: 32, hour1_refund_rate: '1.5%',
		exposure_uv: 180000, click_uv: 27000, exposure_click_rate_uv: '15.0%', click_deal_rate_uv: '8.1%', exposure_deal_rate_uv: '1.2%', thousand_exposure_pay: 697.78, exposure_deal_rate_pv: '0.8%', exposure_pv: 360000, click_pv: 54000, exposure_click_rate_pv: '15.0%', click_deal_rate_pv: '4.8%'
	},
	{
		id: 8, platform: '抖店', shop_name: '宠物用品集合', score: 4.72, violation_status: '正常',
		pay_amount: 98500.00, refund_pay_amount: 91000.00, order_count: 2450, buyer_count: 2100, avg_price: 40.20, deal_amount: 96000.00, net_deal_amount: 88500.00, coupon_amount: 3800.00, refund_coupon_amount: 3400.00, platform_subsidy: 2100.00, refund_platform_subsidy: 1900.00, influencer_subsidy: 1100.00, presale_deposit: 450.00, deal_item_count: 3300, item_price: 29.09, net_order_count: 2300,
		refund_amount_rt: 7500.00, refund_total_rt: 8800.00, refund_amount_pt: 6800.00, refund_total_pt: 8000.00, refund_rate_pt: '8.1%', pre_ship_refund_rate: '2.5%', unreceived_refund_rate: '1.8%', received_refund_rate: '3.8%', received_return_refund_rate: '3.2%', refund_order_count_rt: 180, refund_order_count_pt: 160, hour1_refund_amount: 1200.00, hour1_refund_order_count: 18, hour1_refund_rate: '1.0%',
		exposure_uv: 145000, click_uv: 23200, exposure_click_rate_uv: '16.0%', click_deal_rate_uv: '9.1%', exposure_deal_rate_uv: '1.4%', thousand_exposure_pay: 679.31, exposure_deal_rate_pv: '0.9%', exposure_pv: 290000, click_pv: 46000, exposure_click_rate_pv: '15.9%', click_deal_rate_pv: '5.3%'
	}
];
*/

const STORAGE_KEY_DOUYIN = 'shop_board_field_config_douyin';
const STORAGE_KEY_WECHAT = 'shop_board_field_config_wechat';
const STORAGE_KEY = 'shop_board_field_config'; // 保留旧的键用于兼容

export default {
	name: "ucShopBoard",
	data() {
		return {
			loading: false,
			dataTime: '', // 数据时间
			searchData: {
				platform: 1, // 默认抖店
				shop_id: '',
				group_id: '',
				sales_range: '',
				score_range: '',
				has_violation: '', // 是否有违规筛选
				has_auth: '', // 是否授权筛选
				start_time: '',
				end_time: '',
			},
			shopOptions: [],
			groupList: [],
			groupLoading: false,
			groupListHasCount: false,
			platformOptions: [
				{ value: 1, label: '抖店' },
				{ value: 7, label: '微信小店' },
			],
			salesRangeOptions: [
				{ value: '0-5000', label: '0 - 5000' },
				{ value: '5000-50000', label: '5000 - 5万' },
				{ value: '50000-200000', label: '5万 - 20万' },
				{ value: '200000-500000', label: '20万 - 50万' },
				{ value: '500000+', label: '50万以上' },
			],
			scoreRangeOptions: [
				{ value: '90+', label: '90分以上' },
				{ value: '80-90', label: '80 - 90分' },
				{ value: '70-80', label: '70 - 80分' },
				{ value: '60-70', label: '60 - 70分' },
				{ value: '0-60', label: '60分以下' },
			],
			violationOptions: [
				{ value: 2, label: '今日有违规' },
				{ value: 3, label: '近3天有违规' },
				{ value: 4, label: '近7天有违规' },
				{ value: 1, label: '有违规' },
				{ value: 0, label: '无违规' },
            ],
            authOptions: [
				{ value: 1, label: '已授权' },
				{ value: 2, label: '未授权' },
			],
			timeOptions: [
				{ id: 1, name: '实时', day: 'realtime' },
				{ id: 2, name: '近1天', day: '1' },
				{ id: 3, name: '近7天', day: '7' },
				{ id: 4, name: '近30天', day: '30' },
			],
			timeSelectId: 1,
			customDateRange: '',
			datePickerOptions: {
				onPick: ({ maxDate, minDate }) => {
					if (minDate && !maxDate) {
						// 当选择了开始日期但还没选择结束日期时，禁用超过31天的日期
						this.selectingStartDate = minDate.getTime();
					}
				},
				disabledDate: (time) => {
					// 禁用未来日期
					if (time.getTime() > Date.now()) {
						return true;
					}
					// 如果正在选择日期范围，限制最多31天
					if (this.selectingStartDate) {
						const oneDay = 24 * 60 * 60 * 1000;
						const maxDays = 31;
						const minTime = this.selectingStartDate - maxDays * oneDay;
						const maxTime = this.selectingStartDate + maxDays * oneDay;
						return time.getTime() < minTime || time.getTime() > maxTime;
					}
					return false;
				}
			},
			selectingStartDate: null,
			tableData: [],
			douyinSelectedFields: [...douyinDefaultFields],
			wechatSelectedFields: [...wechatDefaultFields],
			tempSelectedFields: [],
			showFieldConfig: false,
			groupManageVisible: false,
			groupFormVisible: false,
			groupFormEdit: false,
			groupFormLoading: false,
			groupForm: { id: null, name: '', sort: 0 },
			selectedRows: [],
			batchGroupVisible: false,
			batchGroupId: '',
			batchGroupRows: [],
			batchGroupLoading: false,
			// 违规信息弹窗
			showViolationDialog: false,
			violationDialogTitle: '',
			currentShop: null,
			violationList: [],
			violationLoading: false,
			violationPage: {
				page: 1,
				limit: 20,
				total: 0,
			},
            is_host: false,
		}
	},
	components: {
		Pagination,
		myHead, myFoot, ucMenu
	},
	computed: {
		...mapState({
			userinfo: (state) => state.login.userinfo,
		}),
		// 根据当前平台返回对应的字段分组
		fieldGroups() {
			return this.searchData?.platform === 7 ? wechatFieldGroups : douyinFieldGroups;
		},
		// 根据当前平台返回对应的选中字段
		selectedFields() {
			return this.searchData?.platform === 7 ? this.wechatSelectedFields : this.douyinSelectedFields;
		},
		allFieldMap() {
			let map = {};
			this.fieldGroups.forEach(group => {
				group.fields.forEach(f => {
					map[f.key] = { ...f, groupType: group.type, groupName: group.name };
				});
			});
			return map;
		},
		// 按分组聚合当前选中的列，用于多级表头渲染
		activeGroups() {
			let groups = [];
			let groupMap = {};
			this.selectedFields.forEach(key => {
				let col = this.allFieldMap[key];
				if (!col) return;
				if (!groupMap[col.groupType]) {
					let g = { name: col.groupName, type: col.groupType, fields: [] };
					groupMap[col.groupType] = g;
					groups.push(g);
				}
				groupMap[col.groupType].fields.push(col);
			});
			return groups;
		},
		// 显示当前筛选的时间范围
		displayDateRange: {
			get() {
				// 如果有自定义日期范围，直接返回
				if (this.customDateRange && this.customDateRange.length === 2) {
					return this.customDateRange;
				}
				// 如果有明确的开始和结束时间，返回
				if (this.searchData.start_time && this.searchData.end_time) {
					return [this.searchData.start_time, this.searchData.end_time];
				}
				// 根据快捷标签计算日期范围
				if (this.timeSelectId) {
					const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId);
					if (timeOption) {
						if (timeOption.day === 'realtime') {
							const today = this.formatDate(new Date());
							return [today, today];
						} else {
							const today = new Date();
							const days = parseInt(timeOption.day);
							const yesterday = new Date(today);
							yesterday.setDate(yesterday.getDate() - 1);
							const end = this.formatDate(yesterday);
							const start = new Date(yesterday);
							start.setDate(start.getDate() - (days - 1));
							const startDate = this.formatDate(start);
							return [startDate, end];
						}
					}
				}
				return '';
			},
			set(value) {
				// 当用户手动选择日期时，更新 customDateRange
				this.customDateRange = value;
			}
		}
	},
	created() {
		this.loadShopList();
		this.loadGroupList();
		this.loadFieldConfig();
		this.loadData();
        this.is_host = !(this.$store.state.login.is_host === 'false')
	},
	methods: {
		...mapActions({
			getShopDataSummary: "shop_board/getShopDataSummary",
			getShopList: "shop_board/getShopList",
			saveFieldConfig: "shop_board/saveFieldConfig",
			getShopBoardGroupList: "shop_board/getShopBoardGroupList",
			opShopBoardGroupCreate: "shop_board/opShopBoardGroupCreate",
			opShopBoardGroupUpdate: "shop_board/opShopBoardGroupUpdate",
			opShopBoardGroupDelete: "shop_board/opShopBoardGroupDelete",
			opShopBoardBatchSetGroup: "shop_board/opShopBoardBatchSetGroup",
		}),
		loadGroupList(options = {}) {
			const { withCount = false, force = false } = options;
			if (this.groupLoading) return;
			if (!force && this.groupList.length > 0 && (!withCount || this.groupListHasCount)) return;
			this.groupLoading = true;
			this.getShopBoardGroupList({
				data: { with_count: withCount ? 1 : 0 },
				success: (res) => {
					this.groupLoading = false;
					if (res.code === 200) {
						this.groupList = res.data || [];
						this.groupListHasCount = withCount;
						if (this.searchData.group_id && !this.groupList.find(item => item.id === this.searchData.group_id)) {
							this.searchData.group_id = '';
						}
					} else {
						this.$message.error(res.message || '获取分组失败');
					}
				}
			});
		},
		openShopGroupManageDialog() {
			this.groupManageVisible = true;
			this.loadGroupList({ withCount: true, force: true });
		},
		handleAddShopGroup() {
			this.groupForm = { id: null, name: '', sort: 0 };
			this.groupFormEdit = false;
			this.groupFormVisible = true;
		},
		handleEditShopGroup(row) {
			this.groupForm = { id: row.id, name: row.name, sort: row.sort || 0 };
			this.groupFormEdit = true;
			this.groupFormVisible = true;
		},
		submitShopGroupForm() {
			if (!this.groupForm.name || !this.groupForm.name.trim()) {
				this.$message.warning('请输入分组名称');
				return;
			}
			this.groupFormLoading = true;
			const data = { name: this.groupForm.name.trim(), sort: this.groupForm.sort || 0 };
			const callback = (res, successMessage) => {
				this.groupFormLoading = false;
				if (res.code === 200) {
					this.$message.success(successMessage);
					this.groupFormVisible = false;
					this.loadGroupList({ withCount: true, force: true });
				} else {
					this.$message.error(res.message || '操作失败');
				}
			};
			if (this.groupFormEdit) {
				this.opShopBoardGroupUpdate({
					id: this.groupForm.id,
					data,
					success: (res) => callback(res, '修改成功')
				});
				return;
			}
			this.opShopBoardGroupCreate({
				data,
				success: (res) => callback(res, '新增成功')
			});
		},
		handleDeleteShopGroup(row) {
			this.$confirm(`确定删除分组「${row.name}」吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.opShopBoardGroupDelete({
					id: row.id,
					success: (res) => {
						if (res.code === 200) {
							this.$message.success('删除成功');
							this.loadGroupList({ withCount: true, force: true });
							this.loadData();
						} else {
							this.$message.error(res.message || '删除失败');
						}
					}
				});
			}).catch(() => {});
		},
		handleSelectionChange(rows) {
			this.selectedRows = rows || [];
		},
		openShopBatchGroupDialog(rows) {
			const targetRows = Array.isArray(rows) && rows.length > 0 ? rows : this.selectedRows;
			if (!targetRows || targetRows.length === 0) {
				this.$message.warning('请先选择店铺');
				return;
			}
			this.batchGroupRows = targetRows;
			this.batchGroupId = targetRows.length === 1 && targetRows[0].group_id ? targetRows[0].group_id : '';
			this.batchGroupVisible = true;
			this.loadGroupList({ withCount: false, force: this.groupList.length === 0 });
		},
		submitShopBatchSetGroup() {
			if (this.batchGroupId === '' || this.batchGroupId === null) {
				this.$message.warning('请选择分组');
				return;
			}
			const merShopIds = Array.from(new Set(this.batchGroupRows.map(item => Number(item.mer_shop_id)).filter(Boolean)));
			if (merShopIds.length === 0) {
				this.$message.warning('未找到可设置的店铺');
				return;
			}
			this.batchGroupLoading = true;
			const isRemoveGroup = this.batchGroupId === 0;
			this.opShopBoardBatchSetGroup({
				data: {
					mer_shop_ids: merShopIds,
					group_id: isRemoveGroup ? null : this.batchGroupId,
				},
				success: (res) => {
					this.batchGroupLoading = false;
					if (res.code === 200) {
						this.$message.success(isRemoveGroup ? '已移出分组' : '设置成功');
						this.batchGroupVisible = false;
						this.batchGroupRows = [];
						this.selectedRows = [];
						this.loadGroupList({ withCount: this.groupManageVisible, force: true });
						this.loadData();
					} else {
						this.$message.error(res.message || '设置失败');
					}
				}
			});
		},
		// 加载字段配置
		loadFieldConfig() {
			// 加载抖店配置
			let douyinSaved = localStorage.getItem(STORAGE_KEY_DOUYIN);
			console.log('加载抖店配置:', douyinSaved);
			if (douyinSaved) {
				try {
					this.douyinSelectedFields = JSON.parse(douyinSaved);
				} catch (e) {
					this.douyinSelectedFields = [...douyinDefaultFields];
				}
			} else {
				this.douyinSelectedFields = [...douyinDefaultFields];
			}

			// 加载微信配置
			let wechatSaved = localStorage.getItem(STORAGE_KEY_WECHAT);
			console.log('加载微信配置:', wechatSaved);
			if (wechatSaved) {
				try {
					this.wechatSelectedFields = JSON.parse(wechatSaved);
				} catch (e) {
					this.wechatSelectedFields = [...wechatDefaultFields];
				}
			} else {
				this.wechatSelectedFields = [...wechatDefaultFields];
			}

			// 初始化临时选择
			this.tempSelectedFields = [...this.selectedFields];
			console.log('初始化 tempSelectedFields:', this.tempSelectedFields);
		},
		// 打开字段配置弹窗
		openFieldConfig() {
			this.tempSelectedFields = [...this.selectedFields];
			console.log('打开配置弹窗, tempSelectedFields:', this.tempSelectedFields);
			console.log('当前平台:', this.searchData.platform);
			this.showFieldConfig = true;
		},
		// 确认字段配置
		confirmFieldConfig() {
			console.log('确认配置, tempSelectedFields:', this.tempSelectedFields);
			console.log('当前平台:', this.searchData.platform);
			// 根据当前平台保存到对应的配置
			if (this.searchData.platform === 7) {
				this.wechatSelectedFields = [...this.tempSelectedFields];
				localStorage.setItem(STORAGE_KEY_WECHAT, JSON.stringify(this.wechatSelectedFields));
				console.log('保存微信配置:', this.wechatSelectedFields);
			} else {
				this.douyinSelectedFields = [...this.tempSelectedFields];
				localStorage.setItem(STORAGE_KEY_DOUYIN, JSON.stringify(this.douyinSelectedFields));
				console.log('保存抖店配置:', this.douyinSelectedFields);
			}
			this.showFieldConfig = false;
			// Vue 的响应式系统会自动更新 activeGroups
			this.$nextTick(() => {
				console.log('配置已更新, selectedFields:', this.selectedFields);
				console.log('activeGroups:', this.activeGroups);
			});
		},
		// 配置弹窗关闭时
		onConfigClose() {
			// 恢复临时选择为当前平台的配置
			this.tempSelectedFields = [...this.selectedFields];
		},
		// 获取分组已选数量
		getGroupCheckedCount(group) {
			return group.fields.filter(f => this.tempSelectedFields.includes(f.key)).length;
		},
		// 判断分组是否全选
		isGroupAllChecked(group) {
			return group.fields.every(f => this.tempSelectedFields.includes(f.key));
		},
		// 判断分组是否半选
		isGroupIndeterminate(group) {
			let count = this.getGroupCheckedCount(group);
			return count > 0 && count < group.fields.length;
		},
		// 切换分组全选
		toggleGroupAll(group, checked) {
			let keys = group.fields.map(f => f.key);
			if (checked) {
				// 全选：添加所有字段
				let set = new Set(this.tempSelectedFields);
				keys.forEach(k => set.add(k));
				this.tempSelectedFields = [...set];
			} else {
				// 取消全选：移除所有字段
				this.tempSelectedFields = this.tempSelectedFields.filter(k => !keys.includes(k));
			}
		},
		// 表头样式：分组用不同底色
		headerCellStyle({ column }) {
			let base = { color: '#454545', 'font-weight': 'bold', 'font-size': '12px' };
			let cls = column.className || '';
			if (cls.includes('col-group-trade')) return { ...base, background: '#e8f4fd' };
			if (cls.includes('col-group-refund')) return { ...base, background: '#fef0e6' };
			if (cls.includes('col-group-traffic')) return { ...base, background: '#e9f7ef' };
			return { ...base, background: '#eef1f6' };
		},
		headerCellClass({ column }) {
			return column.className || '';
		},
		// 平台 Tab 切换
		handlePlatformTab(platform) {
			this.searchData.platform = platform;
			// 清空店铺筛选
			this.searchData.shop_id = '';
			// 更新临时选择为当前平台的配置
			this.tempSelectedFields = [...this.selectedFields];
			this.selectedRows = [];
			this.batchGroupRows = [];
			if(platform == 1) {
				this.scoreRangeOptions = [
								{ value: '90+', label: '90分以上' },
								{ value: '80-90', label: '80 - 90分' },
								{ value: '70-80', label: '70 - 80分' },
								{ value: '60-70', label: '60 - 70分' },
								{ value: '0-60', label: '60分以下' },
							]
			}
			if(platform == 7) {
				this.scoreRangeOptions = [
								{ value: '4.5-5', label: '4.5 - 5.0分' },
								{ value: '4-4.5', label: '4.0 - 4.5分' },
								{ value: '3.5-4', label: '3.5 - 4.0分' },
								{ value: '3-3.5', label: '3.0 - 3.5分' },
								{ value: '2-3', label: '2.0 - 3.0分' },
								{ value: '0-2', label: '0.0 - 2.0 分' },

							]
			}

			// 重新加载店铺列表（带平台参数）
			this.loadShopList();
			// 重新加载数据
			this.handleSearch();
		},
		// 平台标签样式
		platformClass(platform) {
			if (platform === 1 || platform === '1') return 'douyin';
			if (platform === 7 || platform === '7') return 'wechat';
			return '';
		},
		// 平台名称转换
		platformName(platform) {
			if (platform === 1 || platform === '1') return '抖店';
			if (platform === 7 || platform === '7') return '微信小店';
			return platform;
		},
		// 体验分颜色
		scoreClass(score) {
			if (score >= 90) return 'excellent';
			if (score >= 80) return 'good';
			if (score >= 70) return 'normal';

			if (score >= 4.5 && score <= 5) return 'excellent';
			if (score >= 4  && score < 4.5) return 'good';
			if (score >= 3.5  && score < 4) return 'normal';

			return 'warn';
		},
		// 数据格式化
		formatCell(col, val) {
			if (val === undefined || val === null || val === '') return '--';
			if (col.fmt === 'money') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return '¥' + (n / 10000).toFixed(2) + '万';
				return '¥' + n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
			}
			if (col.fmt === 'num') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return (n / 10000).toFixed(2) + '万';
				return n.toLocaleString('zh-CN');
			}
			if (col.fmt === 'bignum') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return (n / 10000).toFixed(1) + '万';
				return n.toLocaleString('zh-CN');
			}
			if (col.fmt === 'rate') {
				return String(val);
			}
			return val;
		},
		// 单元格样式 — 退款率高标红
		cellClass(col, val) {
			if (col.fmt === 'rate') {
				let n = parseFloat(val);
				if (!isNaN(n)) {
					if (n >= 10) return 'cell_rate cell_rate_high';
					if (n >= 5) return 'cell_rate cell_rate_mid';
				}
				return 'cell_rate';
			}
			return '';
		},
		// 获取分组已选数量
		getGroupCheckedCount(group) {
			return group.fields.filter(f => this.tempSelectedFields.includes(f.key)).length;
		},
		// 分组是否全选
		isGroupAllChecked(group) {
			return group.fields.every(f => this.tempSelectedFields.includes(f.key));
		},
		// 分组是否半选
		isGroupIndeterminate(group) {
			let count = this.getGroupCheckedCount(group);
			return count > 0 && count < group.fields.length;
		},
		// 切换分组全选/取消
		toggleGroupAll(group, checked) {
			let keys = group.fields.map(f => f.key);
			if (checked) {
				let set = new Set(this.tempSelectedFields);
				keys.forEach(k => set.add(k));
				this.tempSelectedFields = [...set];
			} else {
				this.tempSelectedFields = this.tempSelectedFields.filter(k => !keys.includes(k));
			}
		},
		// 时间快捷标签点击
		timeTagClick(item) {
			this.timeSelectId = item.id;
			this.customDateRange = '';
			this.searchData.start_time = '';
			this.searchData.end_time = '';
			this.loadData();
		},
		// 自定义日期变更
		customDateChange() {
			// 重置选择状态
			this.selectingStartDate = null;

			if (this.customDateRange && this.customDateRange.length === 2) {
				// 验证日期范围不超过31天
				const start = new Date(this.customDateRange[0]);
				const end = new Date(this.customDateRange[1]);
				const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

				if (diffDays > 31) {
					this.$message.warning('时间范围不能超过31天');
					this.customDateRange = '';
					return;
				}

				this.timeSelectId = '';
				this.searchData.start_time = this.customDateRange[0];
				this.searchData.end_time = this.customDateRange[1];
			} else {
				this.timeSelectId = 1;
				this.searchData.start_time = '';
				this.searchData.end_time = '';
			}
			this.loadData();
		},
		// 查询
		handleSearch() {
			this.loadData();
		},
		// 重置
		handleReset() {
			this.searchData = {
				platform: 1, // 默认抖店
				shop_id: '',
				group_id: '',
				sales_range: '',
				score_range: '',
				has_violation: '', // 重置违规筛选
				has_auth: '', // 重置授权筛选
				start_time: '',
				end_time: '',
			};
			this.timeSelectId = 1;
			this.customDateRange = '';
			this.selectedRows = [];
			this.batchGroupRows = [];
			this.loadShopList();
			this.loadData();
		},
		// 加载店铺列表
		loadShopList() {
			// 构建请求参数
			let params = {};

			// 如果选择了平台，传递 shop_type（shop_type 就是平台的值）
			if (this.searchData.platform) {
				params.shop_type = this.searchData.platform;
			}
      params.status = 1;

			this.getShopList({
				data: params,
				success: (res) => {
					if (res.code === 200 && res.data) {
						// 数据结构是 data.list.list
						if (res.data.list && res.data.list.list) {
							this.shopOptions = res.data.list.list;
						} else if (Array.isArray(res.data.list)) {
							this.shopOptions = res.data.list;
						} else if (Array.isArray(res.data)) {
							this.shopOptions = res.data;
						} else {
							this.shopOptions = [];
						}
					}
				}
			});
		},
		// 加载数据
		loadData() {
			this.loading = true;

			// 构建请求参数
			let params = {};

			// 平台筛选
			if (this.searchData.platform) {
				params.platform = this.searchData.platform;
			}

			// 店铺筛选
			if (this.searchData.shop_id) {
				params.mer_shop_id = this.searchData.shop_id;
			}

			if (this.searchData.group_id !== '' && this.searchData.group_id !== null) {
				params.group_id = this.searchData.group_id;
			}

			// 营业额范围筛选 - 已隐藏
			// if (this.searchData.sales_range) {
			// 	params.sales_range = this.searchData.sales_range;
			// }

			// 体验分范围筛选
			if (this.searchData.score_range) {
				params.score_range = this.searchData.score_range;
			}

			// 违规状态筛选
			if (this.searchData.has_violation !== '' && this.searchData.has_violation !== null) {
				params.has_violation = this.searchData.has_violation;
            }

			// 授权状态筛选
			if (this.searchData.has_auth !== '' && this.searchData.has_auth !== null) {
				params.has_auth = this.searchData.has_auth;
			}

			// 时间参数
			if (this.searchData.start_time && this.searchData.end_time) {
				params.start_date = this.searchData.start_time;
				params.end_date = this.searchData.end_time;
				params.is_realtime = 0;
			} else {
				const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId);
				if (timeOption && timeOption.day === 'realtime') {
					const today = this.formatDate(new Date());
					params.start_date = today;
					params.end_date = today;
					params.is_realtime = 1;
				} else {
					const today = new Date();
					const days = timeOption ? parseInt(timeOption.day) : 1;
					const yesterday = new Date(today);
					yesterday.setDate(yesterday.getDate() - 1);
					const end = this.formatDate(yesterday);
					const start = new Date(yesterday);
					start.setDate(start.getDate() - (days - 1));
					params.start_date = this.formatDate(start);
					params.end_date = end;
					params.is_realtime = 0;
				}
			}

			this.getShopDataSummary({
				data: params,
				success: (res) => {
					this.loading = false;
					if (res.code === 200 && res.data) {
						// 提取数据时间
						if (res.data.data_time) {
							this.dataTime = res.data.data_time;
						}

						// 接口返回的 data 可能是数组或对象
						if (Array.isArray(res.data)) {
							this.tableData = res.data;
						} else if (res.data.list) {
							// 如果是对象格式（包含 list）
							this.tableData = Array.isArray(res.data.list) ? res.data.list : [];
						} else {
							this.tableData = [];
						}
					} else {
						this.$message.error(res.msg || res.message || '获取数据失败');
						this.tableData = [];
						this.dataTime = '';
					}
				}
			});
		},
		// 格式化日期为 yyyy-MM-dd
		formatDate(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		// 跳转详情页
		goDetail(row) {
			// 根据平台跳转到不同的详情页
			const platform = row.platform || row.shop_type;
			if (platform === 7 || platform === '7') {
				// 微信小店 - 跳转到微信专用详情页
				this.$router.push({
					path: '/uc_shop_board_detail_wechat',
					query: {
						id: row.mer_shop_id || row.shop_id,
						shop_name: row.shop_name
					}
				});
			} else {
				// 抖店 - 跳转到原有详情页
				this.$router.push({
					path: '/uc_shop_board_detail',
					query: {
						id: row.mer_shop_id || row.shop_id,
						shop_name: row.shop_name
					}
				});
			}
		},
		// 显示违规信息
		showViolations(row) {
			this.currentShop = row;
			this.violationDialogTitle = `${row.shop_name} - 违规信息`;
			this.showViolationDialog = true;
			this.violationPage.page = 1;
			this.loadViolations();
		},
		// 加载违规记录
		loadViolations() {
			if (!this.currentShop) return;

			this.violationLoading = true;

			const params = {
				mer_shop_id: this.currentShop.mer_shop_id || this.currentShop.shop_id,
				page: this.violationPage.page,
				limit: this.violationPage.limit,
			};

			getShopViolations(params)
				.then(res => {
					this.violationLoading = false;
					if (res.code === 200 && res.data) {
						this.violationList = res.data.list || [];
						this.violationPage.total = res.data.total || 0;
					} else {
						this.$message.error(res.msg || res.message || '获取违规记录失败');
						this.violationList = [];
						this.violationPage.total = 0;
					}
				})
				.catch(err => {
					this.violationLoading = false;
					this.$message.error('获取违规记录失败');
					this.violationList = [];
					this.violationPage.total = 0;
				});
		},
		// 关闭违规弹窗
		onViolationDialogClose() {
			this.currentShop = null;
			this.violationList = [];
			this.violationPage = {
				page: 1,
				limit: 20,
				total: 0,
			};
		},
		// 格式化时间戳
		formatTimestamp(timestamp) {
			if (!timestamp) return '--';
			const date = new Date(timestamp * 1000);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
        setChange(val) {
            // if(this.$store.state.login.user_level == 9 && this.searchData.group_id) {
            //     this.searchData.group_id = ''
            //     this.$message.error('普通会员无法使用分组');
            //     return
            // }
        },
	}
}
</script>

<style scoped>

.center{display: flex;flex: 1;}

.el-card__body{padding:12px 20px;}
/* 标题 */
.board_title{margin-bottom: 12px;display:flex;align-items:center;justify-content:space-between;gap:12px;}
.board_title h3{font-size: 16px;color: #303133;font-weight: 600;margin: 0;line-height: 1;}
.board_title_actions{display:flex;align-items:center;gap:8px;}
/* 筛选区域 */
.filter_wrap{padding-bottom: 10px;}

/* 数据时间显示 */
.data_time_info{padding: 2px 0;margin-top: 5px;font-size: 12px;color: #606266;text-align: right;}
.data_time_label{font-weight: 400;color: #909399;}
.data_time_value{color: #606266;font-weight: 400;margin-left: 4px;}

/* 平台类型 Tab */
.platform_tabs_wrap{display: flex;align-items: center;gap: 12px;margin-bottom: 15px;padding: 16px 0;border-bottom: 1px solid #f0f0f0;}
.platform_tab{padding: 10px 28px;border-radius: 20px;cursor: pointer;font-size: 15px;color: #666;background: #f5f5f5;border: 1px solid #e0e0e0;transition: all 0.2s ease;}
.platform_tab:hover{background: #fff0ef;border-color: #ffccc7;color: #f0413e;}
.platform_tab.active{font-weight: bold;color: #fff;background: linear-gradient(135deg, #f0413e, #ff6b5a);border-color: transparent;box-shadow: 0 2px 8px rgba(240,65,62,0.3);}

.filter_row{display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;}
.filter_row:last-child{margin-bottom: 0;}
.filter_item{display: flex;align-items: center;margin-right: 15px;margin-bottom: 5px;}
.filter_label{font-size: 13px;color: #606266;white-space: nowrap;}
.filter_btns{margin-left: auto;display: flex;align-items: center;}
.selected_hint{font-size:12px;color:#909399;margin-right:10px;}

/* 时间快捷标签 */
.time_tag{display: inline-block;padding: 4px 10px;font-size: 13px;color: #737E97;cursor: pointer;border-radius: 4px;margin-right: 4px;transition: all 0.2s;}
.time_tag:hover{color: #409EFF;}
.time_tag.active{color: #fff;background: #409EFF;}

/* 店铺名称单元格 */
.shop_name_cell{display: flex;flex-direction: column;align-items: flex-start;gap: 4px;}
.shop_name{font-size: 14px;font-weight: 600;color: #303133;line-height: 1.4;}
.shop_group_tag{display:inline-block;max-width:100%;padding:2px 8px;border:1px solid #dcdfe6;border-radius:10px;background:#f7f8fa;font-size:12px;line-height:1.3;color:#606266;word-break:break-all;}
.shop_group_tag_empty{border-style:dashed;background:#fafafa;color:#c0c4cc;}

/* 平台标签 - 小型版本（放在店铺名称下方）*/
.platform_tag_small{display: inline-block;padding: 1px 6px;border-radius: 2px;font-size: 11px;font-weight: 500;line-height: 1.4;}
.platform_tag_small.douyin{background: #fff0f0;color: #e4393c;}
.platform_tag_small.wechat{background: #e9f7ef;color: #07c160;}

/* 平台标签 - 原始版本（保留用于其他地方）*/
.platform_tag{display: inline-block;padding: 2px 8px;border-radius: 3px;font-size: 12px;font-weight: 500;}
.platform_tag.douyin{background: #fff0f0;color: #e4393c;}
.platform_tag.wechat{background: #e9f7ef;color: #07c160;}

/* 体验分标签 */
.score_badge{display: inline-block;padding: 1px 8px;border-radius: 10px;font-size: 13px;font-weight: bold;}
.score_badge.excellent{background: #e9f7ef;color: #27ae60;}
.score_badge.good{background: #e8f4fd;color: #2980b9;}
.score_badge.normal{background: #fef9e7;color: #f39c12;}
.score_badge.warn{background: #fdedec;color: #e74c3c;}

/* 违规状态 */
.status_dot{display: inline-block;width: 6px;height: 6px;border-radius: 50%;background: #67c23a;margin-right: 4px;vertical-align: middle;}
.status_dot.danger{background: #f56c6c;}
.text-danger{color: #F56C6C;font-weight: bold;}
.text-success{color: #67c23a;font-weight: bold;}

/* 表头精简列名 */
.col_header{font-size: 12px;white-space: nowrap;}

/* 单元格格式化 */
.cell_rate{color: #606266;}
.cell_rate_mid{color: #e6a23c;font-weight: 500;}
.cell_rate_high{color: #f56c6c;font-weight: bold;}

/* 操作列按钮 */
.action_btns{display: flex;flex-direction: column;align-items: center;gap: 3px;}
.action_btns .el-button{margin: 0;width: 70px;padding: 5px 8px;font-size: 12px;}

/* 分组列底色 */
:deep(.col-group-trade){background: rgba(232,244,253,0.25) !important;}
:deep(.col-group-refund){background: rgba(254,240,230,0.25) !important;}
:deep(.col-group-traffic){background: rgba(233,247,239,0.25) !important;}

/* 分页 */
.turn_page{display: flex;justify-content: flex-end;margin-top: 10px;}

/* 指标配置弹窗 */
.field_config_body{max-height: 450px;overflow-y: auto;}
.field_group{margin-bottom: 20px;}
.field_group:last-child{margin-bottom: 0;}
.group_title{font-weight: bold;font-size: 14px;color: #303133;margin-bottom: 10px;padding-bottom: 6px;border-bottom: 1px solid #EBEEF5;display: flex;align-items: center;justify-content: space-between;}
.group_count{font-weight: normal;font-size: 12px;color: #909399;}
.field_group .el-checkbox{width: 240px;margin-right: 10px;margin-bottom: 8px;}
.group_manage_toolbar{display:flex;justify-content:flex-end;margin-bottom:12px;}
.group_manage_body{min-height:120px;max-height:420px;overflow-y:auto;}
.batch_group_tip{font-size:13px;color:#606266;}

:deep(.shop-group-manage-dialog){display:flex;flex-direction:column;max-height:560px;}
:deep(.shop-group-manage-dialog .el-dialog__body){overflow:hidden;padding-top:16px;padding-bottom:18px;}

:deep(.el-table th.el-table__cell>.cell){
	padding: 0 5px !important;
}
:deep(.el-table td.el-table__cell>.cell){
	padding: 0 6px !important;
	font-size: 13px;
}
.el-table .cell{white-space: nowrap;text-overflow: initial;}
</style>
